import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { FormGroup, FormArray, FormBuilder, FormControl, Validators, AbstractControl } from '@angular/forms';
import { MatSelect } from '@angular/material/select';
import { Router, ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ReplaySubject, Subject, takeUntil } from 'rxjs';
import { ApiUrlHelper } from 'src/app/common/apiUrlHelper';
import { CommonConstant } from 'src/app/constants/common-constant';
import { QuestionConstant } from 'src/app/constants/label-constants';
import { QuestionImage } from 'src/app/constants/message-constant';
import { QuestionType } from 'src/app/enum/question-enum';
import { QuestionModel, questionOptions } from 'src/app/models/questionModel';
import { EncrDecrService } from 'src/app/services/EncrDecr.service';
import { CommonService } from 'src/app/services/common/common.service';
interface Questions {
  id: string;
  value: string;
}
interface Questionset {
  id: string;
  value: string;
}
@Component({
  selector: 'app-question-edit',
  templateUrl: './question-edit.component.html',
  styleUrls: ['./question-edit.component.scss']
})
export class QuestionEditComponent {
  @ViewChild('fileQuestion') myfileQuestionElementRef!: ElementRef;
  questionOptionArray: Array<questionOptions> = [];
  files!: File;
  imageURL: any;
  enum: typeof QuestionType = QuestionType;
  showImage: boolean = false;
  ParagraphObj: any;
  showParagraphText: boolean = false;
  showRadio: boolean = true;
  showMultiSelect: boolean = false;
  SingleSelect: boolean = false;
  initalValues: any;
  saveStatus: boolean = false;
  formUnchanged = false;
  questionTypeList: any = [];
  questionSetList: any = [];
  questionEditForm: FormGroup = this.formBuilder.group({});
  QuestionForm: FormGroup = this.formBuilder.group({});
  QuestionId: number = 0;
  ParagraphId: number = 0;
  QuestionTypeId: number = 0;
  optionCheckItem: FormArray<any> | undefined;
  atLeastParagraphOneCheckboxChecked: boolean = false;
  multiQuestionCheckItem: FormArray<any> | undefined;
  multiOptionCheckItem: FormArray<any> | undefined;
  questionSetIdDefault: number = 0;
  fileName = '';
  oldAndNewOptions: any = [];
  atLeastOneCheckboxChecked = false;
  CommonConstant: any = [];
  QuestionConstant: any = [];
  optionValue: any;
  protected AllQuestionlist: Questions[] = this.questionTypeList;
  protected AllQuestionsetlist: Questionset[] = this.questionSetList;
  public FilterCtrl: FormControl = new FormControl();
  public Ctrl: FormControl = new FormControl();
  public filteredData: ReplaySubject<any> = new ReplaySubject();
  public filteredquestionsetData: ReplaySubject<any> = new ReplaySubject();

  @HostListener('window:beforeunload', ['$event'])
  public canDeactivate(event: any): any {
    if (event.type == 'beforeunload') {
      if (this.CommonService.onFormValueChange(this.saveStatus, this.initalValues, this.questionEditForm.getRawValue())) {
        event.preventDefault();
        event.returnValue = false;
      }
    }
    else {
      return this.CommonService.onFormValueChange(this.saveStatus, this.initalValues, this.questionEditForm.getRawValue());
    }
  }

  @ViewChild('singleSelect', { static: true })
  singleSelect!: MatSelect;

  protected _onDestroy = new Subject();
  ngOnDestroy() {
    this._onDestroy.next(1);
    this._onDestroy.complete();
  }
  protected filterdata() {
    if (!this.questionTypeList) {
      return;
    }
    let search = this.FilterCtrl.value;
    if (!search) {
      this.filteredData.next(this.questionTypeList.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredData.next(
      this.questionTypeList.filter(data => data.value.toLowerCase().indexOf(search) > -1)
    );
  }

  protected questionsetData() {
    if (!this.questionSetList) {
      return;
    }
    let search = this.Ctrl.value;
    if (!search) {
      this.filteredquestionsetData.next(this.questionSetList.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredquestionsetData.next(
      this.questionSetList.filter(data => data.value.toLowerCase().indexOf(search) > -1)
    );
  }

  constructor(
    private formBuilder: FormBuilder,
    public CommonService: CommonService,
    private toster: ToastrService,
    private router: Router,
    private route: ActivatedRoute,
    private apiUrl: ApiUrlHelper,
    private EncrDecr: EncrDecrService,
    private spinner: NgxSpinnerService
  ) { }

  minArrayLength(minLength: number) {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const formArray = control as FormArray;
      if (formArray.length >= minLength) {
        return null;
      } else {
        return { minArrayLength: { requiredLength: minLength, actualLength: formArray.length } };
      }
    };
  }

  async ngOnInit() {
    this.filteredData.next(this.questionTypeList.slice());
    this.FilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterdata();
      });
    this.filteredquestionsetData.next(this.questionSetList.slice());
    this.Ctrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.questionsetData();
      });
    this.CommonConstant = CommonConstant;
    this.QuestionConstant = QuestionConstant;
    this.questionEditForm = new FormGroup({
      questionId: new FormControl(0),
      questionText: new FormControl('', [Validators.required, Validators.maxLength(500)]),
      questionTypeId: new FormControl('', [Validators.required]),
      questionSetId: new FormControl('', [Validators.required]),
      paragraphText: new FormControl(''),
      questionImage: new FormControl(),
      questionOptions: this.formBuilder.array([], this.minArrayLength(2)),
      multiQuestions:
        new FormArray([])
    });
    this.route.params.subscribe((params) => {
      if (params['id'] !== undefined && params['type'] != 'paragraph') {
        var decrypted = params['id'] ? params['id'] : '';
        this.QuestionId = Number(this.EncrDecr.get('123456$#@$^@1ERF', decrypted));
      }
      else {
        var decrypted = params['id'] ? params['id'] : '';
        this.ParagraphId = Number(this.EncrDecr.get('123456$#@$^@1ERF', decrypted));
      }
    })
    if (this.QuestionId > 0) {
      this.questionEditForm.get('questionTypeId')?.disable();
      this.getQuestionById(this.QuestionId);
    }
    else if (this.ParagraphId > 0) {
      this.questionEditForm.get('questionTypeId')?.disable();
      this.questionEditForm.get('questionSetId')?.disable();
      this.getParagraphById(this.ParagraphId);
    }
    else {
      this.QuestionId = 0;
      this.ParagraphId = 0;
    }
    this.getQuestionTypeList();
    this.getQuestionSetList();
  }

  getMultiOptions(form) {
    return form.controls.multiOptions.controls;
  }

  getQuestionById(QuestionId: number) {
    this.spinner.show();
    const apiUrl = this.apiUrl.apiUrl.question.GetQuestionById.replace("{id}", QuestionId.toString());
    this.CommonService.doGet(apiUrl).pipe().subscribe({
      next: (data) => {
        this.questionEditForm.patchValue({
          questionText: data.data[0].questionText,
          questionTypeId: data.data[0].questionTypeId,
          questionSetId: data.data[0].questionSetId,
          paragraphText: data.data[0].paragraphText,
          questionImage: data.data[0].imageName,
        });
        this.onQuestionTypeChange();
        this.imageURL = data.data[0].imageName;
        this.QuestionTypeId = Number(this.questionEditForm.controls['questionTypeId'].value);
        if (this.QuestionTypeId == this.enum.MultiSelection ||
          this.QuestionTypeId == this.enum.ImageWithMultiSelection) {
          this.showMultiSelect = true;
          this.showRadio = false;
        }
        else if (this.QuestionTypeId == this.enum.SingleSelection ||
          this.QuestionTypeId == this.enum.ImageWithSingleSelection ||
          this.QuestionTypeId == this.enum.ParagraphWithSingleSelection) {
          this.showMultiSelect = false;
          this.showRadio = true;
        }
        if (this.QuestionTypeId == this.enum.ImageWithMultiSelection ||
          this.QuestionTypeId == this.enum.ImageWithSingleSelection) {
          this.showImage = true;
          this.showParagraphText = false;
        }
        else {
          this.showImage = false;
        }
        if (this.QuestionTypeId == this.enum.ParagraphWithSingleSelection) {
          this.showImage = false;
          this.showParagraphText = true;
        }
        else {
          this.showParagraphText = false;
        }
        const optionsArray = this.questionEditForm.get('questionOptions') as FormArray;
        data.data[0].questionOptiontList.forEach(option => {
          const optionFormGroup = this.formBuilder.group({
            isDeleted: false,
            questionOptionId: option.questionOptionId,
            optionText: [option.optionText, [Validators.required, Validators.maxLength(180)]],
            isCorrectAnswer: [option.isCorrectOption, [Validators.required]]
          });
          optionsArray.push(optionFormGroup);
        });
        this.optionValue = data.data[0].questionOptiontList;
        this.initalValues = this.questionEditForm.getRawValue();
      },
      error: (err) => {
        this.spinner.hide();
      }
    });
  }

  getParagraphById(paragraphId: number) {
    this.spinner.show();
    const apiUrl = this.apiUrl.apiUrl.question.GetParagraphById.replace("{id}", paragraphId.toString());
    this.CommonService.doGet(apiUrl).pipe().subscribe({
      next: (data) => {
        this.showParagraphText = true;
        this.questionEditForm.patchValue({
          questionId: data.data.questionList[0].questionId,
          questionText: data.data.questionList[0].questionText,
          questionTypeId: data.data.questionTypeId,
          questionSetId: data.data.questionSetId,
          paragraphText: data.data.paragraphText,
          questionImage: "",
        });
        this.questionSetIdDefault = data.data.questionSetId;
        this.onQuestionTypeChange();
        const optionsArray = this.questionEditForm.get('questionOptions') as FormArray;
        data.data.questionList[0].questionOptiontList.forEach(option => {
          const optionFormGroup = this.formBuilder.group({
            isDeleted: false,
            questionOptionId: option.questionOptionId,
            optionText: [option.optionText, [Validators.required, Validators.maxLength(180)]],
            isCorrectAnswer: [option.isCorrectOption, [Validators.required]]
          });
          optionsArray.push(optionFormGroup);
        });
        let multiQuestion = this.getMultiQuestionArrayControl();
        for (let i = 1; i < data.data.questionList.length; i++) {
          this.addQuestion();
          let multiQuestionGroup = this.multiQuestionCheck(i - 1);
          multiQuestionGroup.patchValue({
            multiQuestionId: data.data.questionList[i].questionId,
            multiQuestionText: data.data.questionList[i].questionText
          });
          let control = multiQuestion.at(i - 1).get('multiOptions') as FormArray;
          data.data.questionList[i].questionOptiontList.forEach(option => {
            const multiOptionFormGroup = this.formBuilder.group({
              isDeleted: false,
              questionOptionId: option.questionOptionId,
              multiOptionText: [option.optionText, [Validators.required, Validators.maxLength(180)]],
              isCorrectAnswer: [option.isCorrectOption, [Validators.required]]
            });
            control.push(multiOptionFormGroup);
          });
        }
        this.initalValues = this.questionEditForm.getRawValue();
        this.spinner.hide();
      },
      error: (err) => {
        this.spinner.hide();
      }
    });
  }

  initMultiQuestion() {
    return new FormGroup({
      multiQuestionId: new FormControl(null),
      multiQuestionText: new FormControl(null, [Validators.required]),
      multiOptions: new FormArray([], this.minArrayLength(2))
    });
  }

  initMultiOptions() {
    return new FormGroup({
      isDeleted: new FormControl(false),
      multiOptionText: new FormControl(null, [Validators.required, Validators.maxLength(180)]),
      isCorrectAnswer: new FormControl(false, [Validators.required]),
      questionOptionId: new FormControl(0, [Validators.required])
    });
  }

  addQuestion() {
    const control = <FormArray>this.questionEditForm.get('multiQuestions');
    control.push(this.initMultiQuestion());
  }

  multiQuestionCheck(index) {
    this.multiQuestionCheckItem = this.questionEditForm.get('multiQuestions') as FormArray;
    const formGroup = this.multiQuestionCheckItem.controls[index] as FormGroup;
    return formGroup;
  }

  getMultiQuestionArrayControl(): FormArray {
    return this.questionEditForm.get('multiQuestions') as FormArray;
  }

  getMultiQuestions(form) {
    return form.controls.multiQuestions.controls;
  }

  // Get multiQuestions FormArray
  get multiQuestions(): FormArray {
    return this.questionEditForm.get('multiQuestions') as FormArray;
  }

  // Get multiOptions at perticular Index number
  multiOptions(i: number): FormArray {
    const multiOptions = this.multiQuestions.at(i) as FormGroup
    return multiOptions.get('multiOptions') as FormArray
  }

  // Reset Form
  resetForm() {
    this.questionEditForm = new FormGroup({
      questionId: new FormControl(0),
      questionText: new FormControl('', [Validators.required, Validators.maxLength(500)]),
      questionTypeId: new FormControl('', [Validators.required]),
      questionSetId: new FormControl('', [Validators.required]),
      paragraphText: new FormControl(''),
      questionImage: new FormControl(),
      questionOptions: this.formBuilder.array([], this.minArrayLength(2)),
      multiQuestions:
        new FormArray([])
    });
    this.initalValues = this.questionEditForm.getRawValue();
  }

  editQuestion() {
    if (this.ParagraphId == 0) {
      let optionRequest = {};
      this.questionOptionArray = [];
      const uniqueSet = new Set(this.questionEditForm.value.questionOptions);
      this.oldAndNewOptions.forEach(item => {
        uniqueSet.add(item);
      });
      this.questionEditForm.value.questionOptions = Array.from(uniqueSet);
      let length = this.questionEditForm.value.questionOptions ? this.questionEditForm.value.questionOptions.length : 0
      for (var i = 0; i < length; i++) {
        if (this.questionEditForm.status) {
          var ans = this.questionEditForm.value.questionOptions ?
            (this.questionEditForm.value.questionOptions[i].isCorrectAnswer == undefined || String(this.questionEditForm.value.questionOptions[i].isCorrectAnswer) == '') ?
              false : Boolean(this.questionEditForm.value.questionOptions[i].isCorrectAnswer) : false
          let optionObj: questionOptions = {
            questionOptionId: this.questionEditForm.value.questionOptions[i].questionOptionId,
            optionText: this.questionEditForm.value.questionOptions ? this.questionEditForm.value.questionOptions[i].optionText.trim() : '',
            isCorrectOption: ans,
            isDeleted: this.questionEditForm.value.questionOptions[i].isDeleted
          };
          this.questionOptionArray.push(optionObj);
          optionRequest = {
            insertUpdateOptionRequestModel: this.questionOptionArray
          }
        }
      }
      if (this.questionEditForm.valid && this.atLeastOneCheckboxChecked && !(this.checkSameOptionFunction())) {
        this.saveStatus = true;
        this.spinner.show();
        var filename;
        if (!this.files && (this.questionEditForm.controls['questionTypeId'].value == this.enum.ImageWithSingleSelection ||
          this.questionEditForm.controls['questionTypeId'].value == this.enum.ImageWithMultiSelection)) {
          filename = new URL(this.questionEditForm.controls['questionImage'].value).pathname.split('/').pop();
        }
        let formData = new FormData()
        formData.append('file', this.files ? this.files : filename);
        formData.append('QuestionId', this.QuestionId.toString());
        formData.append('QuestionText', this.questionEditForm.controls['questionText'].value ? this.questionEditForm.controls['questionText'].value.trim() : '');
        formData.append('ParagraphText', this.questionEditForm.controls['paragraphText'].value ? this.questionEditForm.controls['paragraphText'].value.trim() : '');
        formData.append('QuestionTypeId', this.questionEditForm.controls['questionTypeId'].value ? this.questionEditForm.controls['questionTypeId'].value : '');
        formData.append('QuestionSetId', this.questionEditForm.controls['questionSetId'].value ? this.questionEditForm.controls['questionSetId'].value : '');
        formData.append('QuestionOptiontJsonString', JSON.stringify(optionRequest['insertUpdateOptionRequestModel']));
        formData.append('ImageName', filename);
        const apiUrl = this.apiUrl.apiUrl.question.UpdateQuestion;
        this.CommonService.doPut(apiUrl, formData).pipe().subscribe({
          next: async (data) => {
            if (data.success) {
              this.questionEditForm.reset()
              this.spinner.hide();
              this.router.navigate(['question'])
              this.toster.success(data.message);
            }
            else {
              this.spinner.hide();
              this.toster.error(data.message);
            }
          },
          error: (error) => {
            this.spinner.hide();
            this.CommonService.checkAuthorize(error);
          }
        });
      }
      else {
        this.questionEditForm.markAllAsTouched();
      }
    }
    else {
      if (this.questionEditForm.valid && this.atLeastParagraphOneCorrectFunction() && this.answerCheckAll() && !(this.checkSameOptionFunction()) && !(this.checkSameQuestion())) {
        this.saveStatus = true;
        this.spinner.show();
        // Create Main Object for sending data
        const objData1 = {
          paragraphId: this.ParagraphId,
          questionTypeId: parseInt(this.questionEditForm.controls['questionTypeId'].value),
          questionSetId: this.questionSetIdDefault,
          paragraphText: this.questionEditForm.controls['paragraphText'].value.toString(),
          questions: [] as any
        }
        let currentQuestionId = this.questionEditForm.controls['questionId'].value ? this.questionEditForm.controls['questionId'].value : '';
        // Object of first Question
        let firstQuestionObj = {
          questionId: this.questionEditForm.controls['questionId'].value ? this.questionEditForm.controls['questionId'].value : '',
          questionStrId: "",
          questionText: this.questionEditForm.controls['questionText'].value ? this.questionEditForm.controls['questionText'].value.trim() : '',
          questionOptions: [] as any,
          isDeleted: false,
          isActive: true
        }
        let optionsLength = this.questionEditForm.value.questionOptions ? this.questionEditForm.value.questionOptions.length : 0;
        for (var i = 0; i < optionsLength; i++) {
          var ans = this.questionEditForm.value.questionOptions ?
            (this.questionEditForm.value.questionOptions[i].isCorrectAnswer == undefined || String(this.questionEditForm.value.questionOptions[i].isCorrectAnswer) == '') ?
              false : Boolean(this.questionEditForm.value.questionOptions[i].isCorrectAnswer) : false
          let optionObj = {
            questionOptionId: this.questionEditForm.value.questionOptions[i].questionOptionId,
            questionStrId: "",
            questionId: currentQuestionId,
            optionText: this.questionEditForm.value.questionOptions[i].optionText ? this.questionEditForm.value.questionOptions[i].optionText.trim() : '',
            isCorrectOption: ans,
            isDeleted: false
          };
          // Append to first Question object
          firstQuestionObj.questionOptions.push(optionObj);
        }
        for (var i = 0; i < this.oldAndNewOptions.length; i++) {
          if (this.oldAndNewOptions[i].questionId == currentQuestionId) {
            let optionObj = {
              questionOptionId: this.oldAndNewOptions[i].option.questionOptionId,
              questionStrId: "",
              questionId: currentQuestionId,
              optionText: this.oldAndNewOptions[i].option.optionText ? this.oldAndNewOptions[i].option.optionText.trim() : '',
              isCorrectOption: false,
              isDeleted: true
            };
            firstQuestionObj.questionOptions.push(optionObj);
          }
        }
        objData1.questions.push(firstQuestionObj);
        let multiQuestionLength = this.questionEditForm.value.multiQuestions ? this.questionEditForm.value.multiQuestions.length : 0;
        for (let i = 0; i < multiQuestionLength; i++) {
          currentQuestionId = this.questionEditForm.value.multiQuestions[i].multiQuestionId
          let multiQuestionObj = {
            questionId: currentQuestionId,
            questionStrId: "",
            questionText: this.questionEditForm.value.multiQuestions[i].multiQuestionText ? this.questionEditForm.value.multiQuestions[i].multiQuestionText : '',
            questionOptions: [] as any,
            isDeleted: false,
            isActive: true
          }
          let multiQuestionOptionLength = this.questionEditForm.value.multiQuestions[i].multiOptions ? this.questionEditForm.value.multiQuestions[i].multiOptions.length : 0;
          for (let j = 0; j < multiQuestionOptionLength; j++) {
            var ans = this.questionEditForm.value.multiQuestions[i].multiOptions ?
              (this.questionEditForm.value.multiQuestions[i].multiOptions[j].isCorrectAnswer == undefined || String(this.questionEditForm.value.multiQuestions[i].multiOptions[j].isCorrectAnswer) == '') ?
                false : Boolean(this.questionEditForm.value.multiQuestions[i].multiOptions[j].isCorrectAnswer) : false
            let optionObj = {
              questionOptionId: this.questionEditForm.value.multiQuestions[i].multiOptions[j].questionOptionId,
              questionStrId: "",
              questionId: currentQuestionId,
              optionText: this.questionEditForm.value.multiQuestions[i].multiOptions[j].multiOptionText ? this.questionEditForm.value.multiQuestions[i].multiOptions[j].multiOptionText.trim() : '',
              isCorrectOption: ans,
              isDeleted: false
            };
            multiQuestionObj.questionOptions.push(optionObj);
          }
          for (var k = 0; k < this.oldAndNewOptions.length; k++) {
            if (this.oldAndNewOptions[k].questionId == currentQuestionId) {
              let optionObj = {
                questionOptionId: this.oldAndNewOptions[k].option.questionOptionId,
                questionStrId: "",
                questionId: currentQuestionId,
                optionText: this.oldAndNewOptions[k].option.multiOptionText ? this.oldAndNewOptions[k].option.multiOptionText.trim() : '',
                isCorrectOption: false,
                isDeleted: true
              };
              multiQuestionObj.questionOptions.push(optionObj);
            }
          }
          objData1.questions.push(multiQuestionObj)
        }
        const apiUrl = this.apiUrl.apiUrl.question.SaveMultiple;
        this.CommonService.doPost(apiUrl, objData1).pipe().subscribe({
          next: async (data) => {
            if (data.success) {
              this.questionEditForm.reset();
              this.showParagraphText = false;
              this.spinner.hide();
              this.router.navigate(['question'])
              this.toster.success(data.message);
            }
            else {
              this.spinner.hide();
              this.toster.error(data.message);
            }
          },
          error: (error) => {
            this.spinner.hide();
            this.CommonService.checkAuthorize(error);
          }
        });
      }
    }
  }

  onQuestionTypeChange() {
    this.QuestionTypeId = Number(this.questionEditForm.controls['questionTypeId'].value);
    // let ParagraphObjIndex = this.questionSetList.findIndex(a => a.id === this.ParagraphSetID);
    // if( ParagraphObjIndex >=0){
    //   this.questionSetList.splice( ParagraphObjIndex,1);
    //   this.questionsetData();
    // }
    switch (this.QuestionTypeId) {

      case this.enum.SingleSelection:
        this.cleareOptionsValue();
        this.showParagraphText = false;
        this.showImage = false;
        this.showRadio = true;
        this.showMultiSelect = false;
        this.questionEditForm.get('questionImage')?.clearValidators();
        this.questionEditForm.get('questionImage')?.setErrors(null);
        this.questionEditForm.get('paragraphText')?.clearValidators();
        this.questionEditForm.get('paragraphText')?.setErrors(null);
        break;
      case this.enum.MultiSelection:
        this.cleareOptionsValue();
        this.showParagraphText = false;
        this.showImage = false;
        this.showRadio = false;
        this.showMultiSelect = true;
        this.questionEditForm.get('questionImage')?.clearValidators();
        this.questionEditForm.get('questionImage')?.setErrors(null);
        this.questionEditForm.get('paragraphText')?.clearValidators();
        this.questionEditForm.get('paragraphText')?.setErrors(null);
        break;
      case this.enum.ImageWithSingleSelection:
        this.cleareOptionsValue();
        this.showParagraphText = false;
        this.showImage = true;
        this.showRadio = true;
        this.showMultiSelect = false;
        this.questionEditForm.get('questionImage')?.addValidators(Validators.required);
        this.questionEditForm.get('paragraphText')?.clearValidators();
        this.questionEditForm.get('paragraphText')?.setErrors(null);
        break;
      case this.enum.ImageWithMultiSelection:
        this.cleareOptionsValue();
        this.showParagraphText = false;
        this.showImage = true;
        this.showRadio = false;
        this.showMultiSelect = true;
        this.questionEditForm.get('questionImage')?.addValidators(Validators.required);
        this.questionEditForm.get('paragraphText')?.clearValidators();
        this.questionEditForm.get('paragraphText')?.setErrors(null);
        break;
      case this.enum.ParagraphWithSingleSelection:
        this.questionSetList.push(this.ParagraphObj);
        this.questionsetData();
        this.cleareOptionsValue();
        this.showParagraphText = true;
        this.showImage = false;
        this.showRadio = true;
        this.showMultiSelect = false;
        this.questionEditForm.get('paragraphText')?.addValidators(Validators.required);
        this.questionEditForm.get('questionImage')?.clearValidators();
        this.questionEditForm.get('questionImage')?.setErrors(null);
        break;
      default:
        console.log(`non-existent size: ${this.enum.SingleSelection}`);
        break;
    }
  }

  cleareOptionsValue() {
    let singleOptionLength = this.questionEditForm.value.questionOptions ? this.questionEditForm.value.questionOptions.length : 0;
    for (let i = 0; i < singleOptionLength; i++) {
      this.getFormGroup(i).get('isCorrectAnswer')?.setValue(false);
    }
  }

  onSelectFile(event) {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      if (this.CommonConstant.FILEFORMAT.includes(event.target.files[0].type)) {
        this.files = event.target.files[0];
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = (event) => {
          this.imageURL = reader.result;
        }
      }
      else {
        this.toster.error(QuestionImage.IMAGE_INVALID);
        this.questionEditForm.get('questionImage')?.addValidators(Validators.required);
        this.myfileQuestionElementRef.nativeElement.value = "";
      }
    }
  }

  onCancel() {
    this.router.navigate(['/question']);
  }

  setQuestionForm(data: QuestionModel) {
    this.QuestionForm.setValue({
      QuestionId: (data.questionId) ? data.questionId : 0,
      QuestionText: data.questionText
    });
  }

  onIsPrimaryContactChecked(index: number) {
    let codeLength = this.questionEditForm.value.questionOptions ? this.questionEditForm.value.questionOptions.length : 0;
    for (let i = 0; i < codeLength; i++) {
      if (i == index) continue;
      this.getFormGroup(i).get('isCorrectAnswer')?.setValue(false);
    }
  }

  onIsMultiPrimaryContactChecked(i: number, j: number) {
    const multiQuestionsArray = this.questionEditForm.get('multiQuestions') as FormArray;
    const multiOptionsArray = multiQuestionsArray.at(i).get('multiOptions') as FormArray;
    // Loop through multiOptions array of each multiQuestion
    multiOptionsArray.controls.forEach((multiOption, optionIndex) => {
      if (optionIndex === j) {
        // Skip the selected multiOption
        return;
      }
      // Reset isCorrectAnswer to false for other multiOptions
      const optionFormGroup = multiOption as FormGroup;
      optionFormGroup.patchValue({ isCorrectAnswer: false });
    });
  }

  getQuestionSetList() {
    this.spinner.show();
    const apiUrl = this.apiUrl.apiUrl.test.GetQuestionSetListWithOutCount;
    this.CommonService.doGet(apiUrl).pipe().subscribe({
      next: (data) => {
        if (data && data.data && data.data.length > 0) {
          for (let i = 0; i < data.data.length; i++) {
            if (data.data[i].questionSetName != 'Paragraph') {
              this.questionSetList.push({ 'id': data.data[i].questionSetId, 'value': data.data[i].questionSetName })
            }
            else {
              this.ParagraphObj = {
                'id': data.data[i].questionSetId, 'value': data.data[i].questionSetName
              }
              // this.questionSetList.push({ 'id': data.data[i].questionSetId, 'value': data.data[i].questionSetName })
            }
            this.AllQuestionsetlist = this.questionSetList;
            this.questionsetData();
            this.spinner.hide();
          }
        }
      },
      error: (err) => {
        console.log('getHandlerList-Error', err);
      }
    });
  }

  getQuestionTypeList() {
    this.spinner.show();
    const apiUrl = this.apiUrl.apiUrl.question.GetQuestionTypes;
    this.CommonService.doGet(apiUrl).pipe().subscribe({
      next: (data) => {
        if (data && data.data && data.data.length > 0) {
          for (let i = 0; i < data.data.length; i++) {
            this.questionTypeList.push({ 'id': data.data[i].questionTypeId, 'value': data.data[i].questionTypeText })
          }
          this.filterdata();
          this.spinner.hide();
        }
      },
      error: (err) => {
        console.log('getHandlerList-Error', err);
      }
    });
  }

  optionCheck(index) {
    this.optionCheckItem = this.questionEditForm.get('questionOptions') as FormArray;
    const formGroup = this.optionCheckItem.controls[index] as FormGroup;
    return formGroup;
  }

  answerCheckAll() {
    var answerItem: any = [];
    this.optionCheckItem = this.questionEditForm.get('questionOptions') as FormArray;
    for (var i = 0; i < this.optionCheckItem.length; i++) {
      var ans = this.optionCheckItem.controls[i] as FormGroup;
      answerItem.push(ans.controls['isCorrectAnswer'].value);
    }
    this.SingleSelect = (this.QuestionTypeId == this.enum.SingleSelection) || (this.QuestionTypeId == this.enum.ParagraphWithSingleSelection) || (this.QuestionTypeId == this.enum.ImageWithSingleSelection);
    this.atLeastOneCheckboxChecked = this.SingleSelect ? (answerItem.filter(x => x === true).length >= 1 ? true : false) : (answerItem.filter(x => x === true).length >= 2 ? true : false);
    return this.atLeastOneCheckboxChecked;
  }

  multiQuestionanswerCheckAll(index: number) {
    var answerItem: any = [];
    this.multiOptionCheckItem = this.questionEditForm.get('multiQuestions') as FormArray;
    const multiOptions = this.multiOptionCheckItem.at(index) as FormGroup
    this.optionCheckItem = multiOptions.get('multiOptions') as FormArray
    for (var i = 0; i < this.optionCheckItem.length; i++) {
      var ans = this.optionCheckItem.controls[i] as FormGroup;
      answerItem.push(ans.controls['isCorrectAnswer'].value);
    }
    this.SingleSelect = (this.QuestionTypeId == this.enum.SingleSelection) || (this.QuestionTypeId == this.enum.ParagraphWithSingleSelection) || (this.QuestionTypeId == this.enum.ImageWithSingleSelection);
    this.atLeastParagraphOneCheckboxChecked = this.SingleSelect ? (answerItem.filter(x => x === true).length >= 1 ? true : false) : (answerItem.filter(x => x === true).length >= 2 ? true : false);
    return this.atLeastParagraphOneCheckboxChecked;
  }

  optionCheckAll() {
    var optionItem: any = [];
    this.optionCheckItem = this.questionEditForm.get('questionOptions') as FormArray;
    for (var i = 0; i < this.optionCheckItem.length; i++) {
      optionItem.push(this.optionCheckItem.controls[i].status);
    }
    return optionItem?.some(x => x === "VALID")
  }

  hasDuplicates(array: any[]): boolean {
    var flag = array.some((value, index) => array.indexOf(value) !== index)
    return flag;
  }

  optionEqualAll() {
    var optionItem: any = [];
    this.optionCheckItem = this.questionEditForm.get('questionOptions') as FormArray;
    for (var i = 0; i < this.optionCheckItem.length; i++) {
      var ans = this.optionCheckItem.controls[i] as FormGroup;
      optionItem.push(ans.controls['optionText'].value);
    }
    return this.hasDuplicates(optionItem);
  }

  optionParagraphEqualAll(i: number) {
    var optionItem: any = [];
    let multiQuestionOptionLength = this.questionEditForm.value.multiQuestions[i].multiOptions ? this.questionEditForm.value.multiQuestions[i].multiOptions.length : 0;
    for (let j = 0; j < multiQuestionOptionLength; j++) {
      optionItem.push(this.questionEditForm.value.multiQuestions[i].multiOptions[j].multiOptionText);
    }
    return this.hasDuplicates(optionItem);
  }

  get questionFormControl() {
    return this.questionEditForm.controls;
  }

  get contacts() {
    return this.questionEditForm.controls['questionOptions'] as FormArray;
  }

  getFormGroup(index: number): FormGroup {
    return this.contacts.at(index) as FormGroup;
  }

  get questionOptions(): FormArray {
    return this.questionEditForm.get('questionOptions') as FormArray;
  }

  //adding option
  addOption(i: number) {
    this.questionOptions.push(
      this.formBuilder.group({
        isDeleted: [false],
        questionOptionId: [0],
        optionText: new FormControl('', [Validators.required, Validators.maxLength(180)]),
        isCorrectAnswer: new FormControl(false, [Validators.required])
      })
    );
  }

  //removing option
  removeOption(i: number) {
    const control = <FormArray>this.questionEditForm.controls['questionOptions'];
    let questionLength = this.questionEditForm.value.questionOptions ? this.questionEditForm.value.questionOptions.length : 0;
    if (this.questionEditForm.value.questionOptions[i - 1].questionOptionId != 0) {
      this.questionEditForm.value.questionOptions[i - 1].isDeleted = true;
      if (this.ParagraphId > 0) {
        let pushObj = {
          questionId: this.questionEditForm.value.questionId,
          option: this.questionEditForm.value.questionOptions[i - 1]
        }
        this.oldAndNewOptions.push(pushObj);
      }
      else {
        this.oldAndNewOptions.push(this.questionEditForm.value.questionOptions[i - 1]);
      }
    }
    if (questionLength > 1) {
      control.removeAt(i - 1);
    }
    else {
      this.questionEditForm.reset();
    }
  }

  //removing option from multiQuestions FromArray on specific number of array
  multiQuestionremoveOption(i: number, j: number) {
    const multiQuestionsArray = this.questionEditForm.get('multiQuestions') as FormArray;
    const questionFormGroup = multiQuestionsArray.at(i) as FormGroup;
    if (questionFormGroup.value.multiQuestionId != 0) {
      questionFormGroup.value.multiOptions[j].isDeleted = true;
      let pushObj = {
        questionId: questionFormGroup.value.multiQuestionId,
        option: questionFormGroup.value.multiOptions[j]
      }
      this.oldAndNewOptions.push(pushObj);
    }
    const control = <FormArray>this.multiOptions(i);
    let codeLength = control ? control.length : 0;
    if (codeLength > 1) {
      control.removeAt(j);
    }
    else {
      this.questionEditForm.reset();
    }
  }

  addOptions(i) {
    this.multiQuestionCheckItem = this.questionEditForm.get('multiQuestions') as FormArray;
    const control = <FormArray>this.multiQuestionCheckItem.controls[i].get('multiOptions');
    control.push(this.initMultiOptions());
  }

  multiOptionCheck(i, j) {
    this.multiOptionCheckItem = this.questionEditForm.get('multiQuestions') as FormArray;
    const multiOptions = this.multiOptionCheckItem.at(i) as FormGroup
    const options = multiOptions.get('multiOptions') as FormArray
    const formGroup = options.at(j) as FormGroup
    return formGroup;
  }

  CheckCorrect(i: number) {
    return this.getFormGroup(i).get('isCorrectAnswer')?.value;
  }

  CheckParagraphCorrect(i: number, j: number) {
    return this.multiOptionCheck(i, j).get('isCorrectAnswer')?.value;
  }

  atLeastParagraphOneCorrectFunction() {
    let currentQuestion: boolean = false;
    let multiQuestionLength = this.questionEditForm.value.multiQuestions ? this.questionEditForm.value.multiQuestions.length : 0;
    for (let i = 0; i < multiQuestionLength; i++) {
      currentQuestion = false;
      let multiQuestionOptionLength = this.questionEditForm.value.multiQuestions[i].multiOptions ? this.questionEditForm.value.multiQuestions[i].multiOptions.length : 0;
      for (let j = 0; j < multiQuestionOptionLength; j++) {
        if (this.questionEditForm.value.multiQuestions[i].multiOptions[j].isCorrectAnswer == true) {
          currentQuestion = true
        }
      }
      if (currentQuestion) {
        this.atLeastParagraphOneCheckboxChecked = true;
      }
      else {
        this.atLeastParagraphOneCheckboxChecked = false;
      }
    }
    return this.atLeastParagraphOneCheckboxChecked;
  }

  checkSameOptionFunction() {
    var optionItem: any = [];
    var flag: boolean = false;
    this.optionCheckItem = this.questionEditForm.get('questionOptions') as FormArray;
    for (var i = 0; i < this.optionCheckItem.length; i++) {
      var ans = this.optionCheckItem.controls[i] as FormGroup;
      optionItem.push(ans.controls['optionText'].value);
    }
    if (this.hasDuplicates(optionItem)) {
      flag = true;
    }
    let multiQuestionLength = this.questionEditForm.value.multiQuestions ? this.questionEditForm.value.multiQuestions.length : 0;
    for (let i = 0; i < multiQuestionLength; i++) {
      optionItem = [];
      let multiQuestionOptionLength = this.questionEditForm.value.multiQuestions[i].multiOptions ? this.questionEditForm.value.multiQuestions[i].multiOptions.length : 0;
      for (let j = 0; j < multiQuestionOptionLength; j++) {
        optionItem.push(this.questionEditForm.value.multiQuestions[i].multiOptions[j].multiOptionText);
      }
      if (this.hasDuplicates(optionItem)) {
        flag = true;
      }
    }
    return flag;
  }

  checkSameQuestion() {
    var QuestionItem: any = [];
    var flag: boolean = false;
    QuestionItem.push(this.questionEditForm.controls['questionText'].value ? this.questionEditForm.controls['questionText'].value.trim() : '');
    let multiQuestionLength = this.questionEditForm.value.multiQuestions ? this.questionEditForm.value.multiQuestions.length : 0;
    for (let i = 0; i < multiQuestionLength; i++) {
      QuestionItem.push(this.questionEditForm.value.multiQuestions[i].multiQuestionText ? this.questionEditForm.value.multiQuestions[i].multiQuestionText.trim() : '');
    }
    return this.hasDuplicates(QuestionItem)
  }
}
